(() => {
  if (customElements.get('image-comparison-slider')) return;

  class ImageComparisonSlider extends HTMLElement {
    connectedCallback() {
      if (this.isInitialized) return;

      this.range = this.querySelector('.image-compare__range');
      this.frame = this.querySelector('.image-compare__frame');
      if (!this.range || !this.frame) return;

      this.isInitialized = true;
      this.handleInput = () => this.queuePositionUpdate();
      this.handleChange = () => {
        this.queuePositionUpdate();
        this.stopDragging();
      };
      this.handlePointerDown = (event) => {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        this.startDragging();
      };
      this.handleKeyUp = (event) => {
        if (['ArrowLeft', 'ArrowRight', 'Home', 'End', 'PageUp', 'PageDown'].includes(event.key)) {
          this.queuePositionUpdate();
        }
      };
      this.handlePointerEnd = () => this.stopDragging();
      this.handleWindowBlur = () => this.stopDragging();

      this.setInitialPosition();

      this.range.addEventListener('input', this.handleInput);
      this.range.addEventListener('change', this.handleChange);
      this.range.addEventListener('pointerdown', this.handlePointerDown);
      this.range.addEventListener('keyup', this.handleKeyUp);
      this.ownerDocument.addEventListener('pointerup', this.handlePointerEnd);
      this.ownerDocument.addEventListener('pointercancel', this.handlePointerEnd);
      window.addEventListener('blur', this.handleWindowBlur);
    }

    disconnectedCallback() {
      if (!this.isInitialized) return;

      this.range.removeEventListener('input', this.handleInput);
      this.range.removeEventListener('change', this.handleChange);
      this.range.removeEventListener('pointerdown', this.handlePointerDown);
      this.range.removeEventListener('keyup', this.handleKeyUp);
      this.ownerDocument.removeEventListener('pointerup', this.handlePointerEnd);
      this.ownerDocument.removeEventListener('pointercancel', this.handlePointerEnd);
      window.removeEventListener('blur', this.handleWindowBlur);

      if (this.animationFrame) window.cancelAnimationFrame(this.animationFrame);
      this.animationFrame = null;
      this.pendingValue = null;
      this.isInitialized = false;
      this.stopDragging();
    }

    setInitialPosition() {
      const isMobile = window.matchMedia('(max-width: 749px)').matches;
      const configuredValue = isMobile ? this.dataset.initialMobile : this.dataset.initialDesktop;
      const initialValue = this.normalizeValue(configuredValue, 50);

      this.range.value = String(initialValue);
      this.applyPosition(this.normalizeValue(this.range.value, initialValue));
    }

    queuePositionUpdate() {
      this.pendingValue = this.normalizeValue(this.range.value, 50);

      if (this.ownerDocument.hidden) {
        this.flushPositionUpdate();
        return;
      }

      if (this.animationFrame) return;

      this.animationFrame = window.requestAnimationFrame(() => {
        this.animationFrame = null;
        this.flushPositionUpdate();
      });
    }

    flushPositionUpdate() {
      if (this.pendingValue === null) return;
      this.applyPosition(this.pendingValue);
      this.pendingValue = null;
    }

    applyPosition(value) {
      const beforeName = this.dataset.beforeName || '左图';
      const afterName = this.dataset.afterName || '右图';

      this.frame.style.setProperty('--compare-position', `${value}%`);
      this.range.setAttribute('aria-valuetext', `${beforeName} ${value}%，${afterName} ${100 - value}%`);
    }

    startDragging() {
      this.classList.add('is-dragging');
    }

    stopDragging() {
      this.classList.remove('is-dragging');
    }

    normalizeValue(value, fallback) {
      const number = Number.parseFloat(value);
      if (!Number.isFinite(number)) return fallback;
      return Math.min(100, Math.max(0, number));
    }
  }

  customElements.define('image-comparison-slider', ImageComparisonSlider);
})();
